import { FaAward } from "react-icons/fa";
import HeroSection from "../../../../ReusableComponent/HeroSection"

const QuizzesHeroSection = () => {
  const stats = [
    { value: "30+", label: "Expert Quizzes" },
    { value: "20K+", label: "Active Students" },
    { value: "95%", label: "Success Rate" },
    { value: "4.8★", label: "Average Rating" },
  ];

  return (
    <HeroSection
      title="Premium Quiz Library"
      subtitle="Master programming skills with our comprehensive assessment platform used by 20,000+ students worldwide"
      icon={<FaAward />}
      stats={stats}
    />
  );
}

export default QuizzesHeroSection;